import { ActivityType } from 'Activities/types'

export function parserActivitiesTypesNamesForIdsFromKey(key: string, filter: any, activitiesTypes: ActivityType[]) {
  const activitiesTypesWithNames = activitiesTypes.filter(({ name }) => {
    return filter[key].includes(name as string)
  })
  if (activitiesTypesWithNames.length > 0) {
    filter[key] = activitiesTypesWithNames.map(({ id }) => id) as string[]
  }
  return filter
}
